/* eslint-disable react/prop-types */
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import './Input.css'

import React from 'react'
import classNames from 'classnames'

import Label from '../../Label'


export default function TextInput({
  label,
  value,
  onChange,
  placeholder = '',
  'data-test-id': dataTestId,
  type = 'text'
}) {
  return (
    <div className={classNames('selectinput', 'form-group')}>
      <Label>{label}</Label>
      <div className="forminput">
        <input
          type={type}
          className="form-control"
          placeholder={placeholder}
          value={value}
          onChange={e => {
            onChange(e.target.value)
          }}
          data-test-id={dataTestId}
        />
      </div>
    </div>
  )
}
